import React from 'react'
import PropTypes from 'prop-types'
import { Link as GatsbyLink } from 'gatsby'
import { styled } from '@material-ui/core/styles'

import { Button as MuiButton, CircularProgress } from '@material-ui/core'

import routes from 'src/routes'

const ProgressInButton = styled(CircularProgress)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  marginTop: -12,
  marginLeft: -12,
})

const StyledDiv = styled('div')({
  position: 'relative',
})

const Button = ({ to, dontUseRoutes, ...props }) => {
  // check if its an internal link
  if (to) {
    if (dontUseRoutes) {
      return <MuiButton component={GatsbyLink} to={to} {...props} />
    }

    if (!routes[to]) {
      throw Error(`LINK TO '${to}' does not exist`)
    }
    // if it is, use the defined routes
    return <MuiButton component={GatsbyLink} to={routes[to]} {...props} />
  } else {
    return <MuiButton component={'button'} {...props} />
  }
}

Button.defaultProps = {
  variant: 'contained',
  disableElevation: true,
  color: 'secondary',
}

Button.propTypes = {
  variant: PropTypes.string,
  to: PropTypes.string,
}

const ButtonContainer = ({ loading, ...props }) => {
  if (loading) {
    return (
      <StyledDiv style={{ display: !props.fullWidth && 'inline-block' }}>
        <Button {...props} /> <ProgressInButton size={24} />{' '}
      </StyledDiv>
    )
  }
  return <Button {...props} />
}

export default ButtonContainer
